import React from 'react';
import { Container } from '@mui/material';
import SchedulingPanel from '../SchedulingPanel';

export default function SchedulingSection() {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <SchedulingPanel />
    </Container>
  );
}